<template>
  <v-container class="pa-0" fluid v-if="myRun.id !== -1">
    <v-layout wrap>
      <v-flex v-if="myRun.config.coronal_model.to_run" xs12>
        <v-subheader>Coronal model</v-subheader>
        <viewer
          :options="{toolbar: false, movable: false, rotatable: false, scalable: false, container: '#app'}"
          class="viewer"
          ref="corViewer"
        >
          <template slot-scope="scope">
            <v-container class="px-3 pb-3 pt-0" fluid grid-list-lg>
              <v-layout row wrap>
                <v-flex
                  :key="i"
                  lg4
                  sm6
                  v-for="(plot, i) in myRun.dataSet.filter(plot => coronalPlots.includes(plot.code))"
                  xs12
                >
                  <v-hover>
                    <v-card
                      :class="`elevation-${hover ? 12 : 2}`"
                      @click="$refs.corViewer.$viewer.view(i)"
                      class="pb-2"
                      slot-scope="{ hover }"
                      style="cursor: pointer;"
                    >
                      <v-img :key="plot.url" :src="plot.url" aspect-ratio="2.15" position="80% 50%">
                        <img :key="plot.url" :src="plot.url" style="display:none;" />
                      </v-img>
                    </v-card>
                  </v-hover>
                </v-flex>
                <v-flex class="text-xs-center" xs12>
                  <v-btn
                    :href="myRun.dataSet.find(data => data.code === 'SWBF').url"
                    color="info"
                  >Download solar wind boundary</v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </template>
        </viewer>
      </v-flex>
      <v-flex v-if="myRun.config.heliospheric_model.to_run" xs12>
        <v-subheader>Heliospheric model</v-subheader>
        <v-container class="px-3 pb-3 pt-0" fluid grid-list-lg>
          <v-layout row wrap>
            <v-flex sm6 v-if="radialSpeedLoop !== null" xs12>
              <vue-perfectlooper :class="'elevation-2'" v-bind="radialSpeedLoop" />
            </v-flex>
            <v-flex sm6 v-if="numberDensityLoop !== null" xs12>
              <vue-perfectlooper :class="'elevation-2'" v-bind="numberDensityLoop" />
            </v-flex>
          </v-layout>
        </v-container>

        <viewer
          :options="{toolbar: false, movable: false, rotatable: false, scalable: false, container: '#app'}"
          class="viewer"
          ref="helViewer"
        >
          <template slot-scope="scope">
            <v-container class="px-3 pb-3 pt-0" fluid grid-list-lg>
              <v-layout row wrap>
                <v-flex
                  :key="i"
                  lg4
                  sm6
                  v-for="(plot, i) in myRun.dataSet.filter(plot => heliosphericPlots.includes(plot.code))"
                  xs12
                >
                  <v-hover>
                    <v-card
                      :class="`elevation-${hover ? 12 : 2}`"
                      @click="$refs.helViewer.$viewer.view(i)"
                      slot-scope="{ hover }"
                      style="cursor: pointer;"
                    >
                      <v-img :key="plot.url" :src="plot.url" aspect-ratio="0.75" position="50% 50%">
                        <img :key="plot.url" :src="plot.url" style="display:none;" />
                      </v-img>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                          :href="myRun.dataSet.find(data => data.code === plot.code.substring(0, 3)+'F').url"
                          color="info"
                          flat
                        >Download data</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-hover>
                </v-flex>
              </v-layout>
            </v-container>
          </template>
        </viewer>
      </v-flex>
      <v-flex xs12>
        <v-subheader>Configuration</v-subheader>
        <v-container class="px-3 pb-3 pt-0" fluid grid-list-lg>
          <v-layout row wrap>
            <v-flex xs12>
              <tree-view
                :data="myRun.config.coronal_model"
                :options="{rootObjectKey: 'Coronal model', maxDepth: 1}"
                v-if="myRun.config.coronal_model.to_run"
              ></tree-view>
            </v-flex>
            <v-flex xs12>
              <tree-view
                :data="myRun.config.heliospheric_model"
                :options="{rootObjectKey: 'Heliospheric model', maxDepth: 1}"
                v-if="myRun.config.heliospheric_model.to_run"
              ></tree-view>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<style>
.perfectlooper .aspectEnforcer {
  padding-bottom: 70% !important;
}
.perfectlooper.fullscreen {
  max-width: 1.428571429vmin !important;
}
body {
  padding-right: 0 !important;
}
</style>


<script>
import _ from 'lodash';
import VuePerfectlooper from 'vue-perfectlooper';
import 'viewerjs/dist/viewer.css';
import Viewer from 'v-viewer/src/component.vue';
import runMixin from '@/mixins/run';

export default {
  mixins: [runMixin],
  components: { VuePerfectlooper, Viewer },
  data() {
    return {
      coronalPlots: ['MAGP', 'OCFP', 'RSBP', 'NDBP', 'RFBP', 'TMBP'],
      heliosphericPlots: ['EAIP', 'MEIP', 'MAIP', 'VEIP', 'SAIP', 'SBIP'],
    };
  },
  mounted() {
    this.$store.dispatch('setTitle', 'Run Output');
    const virtualSpacecraft = new Array(100);
    for (let i = 1; i <= 100; i++) {
      virtualSpacecraft[i] = 'SC' + i + 'P';
    }
    this.heliosphericPlots = this.heliosphericPlots.concat(virtualSpacecraft);
  },
  computed: {
    radialSpeedLoop() {
      const data = _.sortBy(_.filter(this.myRun.dataSet, { code: 'RSCP' }), 'filename');
      if (data.length > 0) {
        return {
          id: 'heliospheric-radial-speed-movie',
          poster: data[0].url,
          src: _.map(data, 'url'),
        };
      }
      return null;
    },
    numberDensityLoop() {
      const data = _.sortBy(_.filter(this.myRun.dataSet, { code: 'NDCP' }), 'filename');
      if (data.length > 0) {
        return {
          id: 'heliospheric-number-density-movie',
          poster: data[0].url,
          src: _.map(data, 'url'),
        };
      }
      return null;
    },
  },
};
</script>
